import { defineComponent as _defineComponent } from 'vue'
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import ProjectSttSettings from "@/features/project-stt-settings/ProjectSttSettings.vue";
import {onMounted, ref} from 'vue'
import {showErrorMessage} from "@/services/ui/messages";
import {getClientInstance} from "@/services/client/clientProvider";
import {ProjectModel} from "@/services/models/entities/projects";
import {useRouter} from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSttSettingsView',
  props: {
    projectId: null
  },
  setup(__props: any) {

const props = __props as {
  projectId: number
}



const router = useRouter()

const isLoading = ref(false)
const project = ref<ProjectModel|undefined>()

onMounted(async () => {
  try {
    isLoading.value=true
    project.value = await getClientInstance().getProjectDetails(props.projectId)
  } catch (e) {
    showErrorMessage(e)
  }finally {
    isLoading.value=false
  }
})

function handleBackButton() {
  router.push({
    name: "projectDetails",
    params: {
      projectId: props.projectId.toString()
    }
  })
}

return { __sfc: true,props, router, isLoading, project, handleBackButton, faArrowLeft, ProjectSttSettings }
}

})